import { config } from '@uhg-abyss/web/tools/config';

export const AUTH_CONFIG = {
  // Microsoft Entra ID endpoints for your tenant
  authorizeUrl: config('SSO_BASE_URL') || 
    'https://login.microsoftonline.com/db05faca-c82a-4b9d-b9c5-0f64b6755421/oauth2/v2.0/authorize',
  tokenUrl: config('Token_Server_URL') ||
    'https://login.microsoftonline.com/db05faca-c82a-4b9d-b9c5-0f64b6755421/oauth2/v2.0/token',

  // Client ID from app registration
  clientId: config('CLIENT_ID') || '1183e16b-f9c5-4ab0-9d56-db08ae8b1c30',

  // Scopes used during authorize
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    `api://${config('CLIENT_ID') || '1183e16b-f9c5-4ab0-9d56-db08ae8b1c30'}/openid`,
  ],

  // UserInfo endpoint
  ssoAuthUserInfoUrl: 'https://graph.microsoft.com/oidc/userinfo',
};
